import { useSrpContext } from '@/src/contexts'
import { Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

export default function Heading() {
    const {
        SEOSrpData: { searchQuery }
    } = useSrpContext()
    const { origin, destination } = searchQuery || {}
    const t = useTranslations('common')
    return (
        <Typography component="h1" variant="h4" color="text.primary" fontWeight="600" mb={2} sx={{ fontSize: 24 }}>
            {t('flightFromOriginToDestination', { origin: origin || '', destination: destination || '' })}
        </Typography>
    )
}
